import { SfccRefundMethod } from "@redotech/cockroachdb-codegen/congodb/sfcc-refund-method";
import type { infer as zInfer } from "zod";
import { object, enum as zEnum } from "zod";

export const setCommerceCloudRefundMethod = {
  name: "setCommerceCloudRefundMethod" as const,
  input: object({ refundMethod: zEnum(SfccRefundMethod) }),
  output: object({ success: object({}).optional() }),
};

export type SetCommerceCloudRefundMethodInput = zInfer<
  typeof setCommerceCloudRefundMethod.input
>;
export type SetCommerceCloudRefundMethodOutput = zInfer<
  typeof setCommerceCloudRefundMethod.output
>;
